import { z } from "zod";

export const ObrasServicosControladosSchema = z.object({
  idServicosControlados: z
    .array(z.number(), { required_error: "Este campo deve ser preenchido!" })
    .nonempty("Este campo deve ser preenchido!"),
});

export type ObrasServicosControladosForm = z.infer<typeof ObrasServicosControladosSchema>;
